<template>
  <img :src="backgroundImage" alt="Wedding Invitation" class="full-invitation-image" />
</template>

<script>
import backgroundImage from '../assets/time.png';

export default {
  name: "WeddingInvitationSection",
  data() {
    return { backgroundImage };
  }
};
</script>

<style scoped>
.full-invitation-image {
  width: 100%;
  height: auto;
}
</style>